import styled from 'styled-components';

export const FlexWrap = styled.div(
  props => `
        display:flex;
        `,
);

export const TotalPaxCountSpan = styled.span(
  props => `
      font-size: ${props.theme.font.custom(14)};
      color:#5d5d5d;
      margin-left:${props.marginLeft ? props.marginLeft : '1rem'};
      margin-top:${props.marginTop ? props.marginTop : ''};
      text-align:left
      `,
);
